<p class="mb-6 text-generic">
    {{ 'COMPANY_INFORMATION.ENTER_DETAILS' | translate }}
</p>

<form [formGroup]="companyInformationForm" class="space-y-8" (ngSubmit)="handleFormSubmission()">
    <!-- Section Title -->
    <p class="text-base font-medium mb-6 text-(--text-muted)">
        {{'COMPANY_INFORMATION.BUSINESS_CLASSIFICATION' | translate}}
    </p>

    <!-- Responsive grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">

        <!-- Business sector -->
        <div class="sm:col-span-2">
            <app-custom-dropdown label="COMPANY_INFORMATION.BUSINESS_SECTOR"
                placeholder="COMPANY_INFORMATION.PLEASE_SELECT" [options]="businessSectorOptions" [isSearchable]="true"
                searchPlaceholder="{{'COMPANY_INFORMATION.SEARCH_BUSINESS_SECTOR' | translate}}"
                (optionSelected)="onDropdownSelect('businessSector', $event)" customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- Business activity -->
        <div>
            <app-input-field label="{{ 'COMPANY_INFORMATION.BUSINESS_ACTIVITY' | translate }}"
                placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0"
                [control]="getControl('businessActivity')"></app-input-field>
                
            <p class="mt-2 text-(--text-secondary) text-sm">{{'COMPANY_INFORMATION.BUSINESS_ACTIVITY_EXAMPLE' |
                translate}}</p>
        </div>

        <!-- Relation type -->
        <div>
            <app-custom-dropdown label="COMPANY_INFORMATION.RELATION_TYPE"
                placeholder="COMPANY_INFORMATION.PLEASE_SELECT" [options]="relationTypeOptions"
                (optionSelected)="onDropdownSelect('relationType', $event)" customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- Merchant Category -->
        <div>
            <app-custom-dropdown label="COMPANY_INFORMATION.MERCHANT_CATEGORY"
                placeholder="COMPANY_INFORMATION.PLEASE_SELECT" [options]="merchantCategoryOptions"
                [isSearchable]="true" searchPlaceholder="{{'COMPANY_INFORMATION.SEARCH_MERCHANT_CATEGORY' | translate}}"
                (optionSelected)="onDropdownSelect('merchantCategory', $event)"
                customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- Empty space for alignment -->
        <div class="sm:block hidden"></div>

        <!-- Specify merchant activity (conditional) -->
        <div class="sm:col-span-2" *ngIf="companyInformationForm.get('merchantCategory')?.value === 'Other'">
            <app-input-field label="{{ 'COMPANY_INFORMATION.SPECIFY_MERCHANT_ACTIVITY' | translate }}"
                placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0"
                [control]="getControl('specifyMerchantActivity')"></app-input-field>
        </div>



        <!-- Section Title -->
        <p class="text-base font-medium mb-0 sm:col-span-2 text-(--text-muted)">
            {{'COMPANY_INFORMATION.BUSINESS_SCALE' | translate}}
        </p>

        <!-- Business size -->
        <div>
            <app-custom-dropdown label="COMPANY_INFORMATION.BUSINESS_SIZE"
                placeholder="COMPANY_INFORMATION.PLEASE_SELECT" [options]="businessSizeOptions"
                (optionSelected)="onDropdownSelect('businessSize', $event)" customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- Number of employees -->
        <div>
            <app-custom-dropdown label="COMPANY_INFORMATION.NUMBER_OF_EMPLOYEES"
                placeholder="COMPANY_INFORMATION.PLEASE_SELECT" [options]="numberOfEmployeesOptions"
                (optionSelected)="onDropdownSelect('numberOfEmployees', $event)"
                customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- Section Title -->
        <p class="text-base font-medium mb-0 sm:col-span-2 text-(--text-muted)">
            {{'COMPANY_INFORMATION.FINANCIAL_OVERVIEW' | translate}}
        </p>

        <!-- Company capital -->
        <div>
            <app-custom-dropdown label="COMPANY_INFORMATION.COMPANY_CAPITAL"
                placeholder="COMPANY_INFORMATION.PLEASE_SELECT" [options]="companyCapitalOptions"
                (optionSelected)="onDropdownSelect('companyCapital', $event)" customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- Annual revenues -->
        <div>
            <app-custom-dropdown label="COMPANY_INFORMATION.ANNUAL_REVENUES"
                placeholder="COMPANY_INFORMATION.PLEASE_SELECT" [options]="annualRevenuesOptions"
                (optionSelected)="onDropdownSelect('annualRevenues', $event)" customClass="!mb-0"></app-custom-dropdown>
        </div>

    </div>

    <!-- Submit Button -->

    <app-button text="{{ 'COMPANY_INFORMATION.CONTINUE' | translate }}" type="submit" variant="primary" size="lg"
        extraClass="mt-3 mb-12 w-full" [disabled]="companyInformationForm.invalid"></app-button>

</form>